export default "__VITE_ASSET__5ca8e54a__"